import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const CrossIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="1.46484"
        width="15.8786"
        height="2.07112"
        rx="1.03556"
        transform="rotate(45 1.46484 0)"
        {...svgAttrs}
      />
      <rect
        y="11.228"
        width="15.8786"
        height="2.07112"
        rx="1.03556"
        transform="rotate(-45 0 11.228)"
        {...svgAttrs}
      />
    </svg>
  );
};

export default CrossIcon;
